const SRTTServiceAdvisoryTable1 = {
  Table1: [
    {
      id: "7",
      Source: "NOVA",
      PriorityClass: "P7",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "",
      Source: "ICP",
      PriorityClass: "P2",
      TicketType: "ICP",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "Connection Failure",
      srcasecategory: "PPPOE - Cannot Connect (OFF)",
      srstatus: "Assigned",
      assignment: "TM CCR Technical CPC Follow Up",
      CttTicketType: "Customer TT",
      TicketSubType: "Trouble Report (TR)",
      cttcategory: "NA",
      cttdiagnosiscode: "LOCAL_LOOP",
      cttsymptomcode: "DSL_LineDisconnect",
      serviceaffected: "NA",
      ActivityType: "NA",
      cttstatus: "Pending Assigned",
    },
    {
      id: "",
      Source: "NOVA",
      PriorityClass: "P15",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Frequent disconnection",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Intermittent",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "",
      Source: "ICP",
      PriorityClass: "P3",
      TicketType: "ICP",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "Unstable Connection",
      srcasecategory: "Intermitent",
      srstatus: "Assigned",
      assignment: "TM CCR Technical CPC Follow Up",
      CttTicketType: "Customer TT",
      TicketSubType: "Trouble Report (TR)",
      cttcategory: "NA",
      cttdiagnosiscode: "LOCAL_LOOP",
      cttsymptomcode: "DSL_Slow_Physical",
      serviceaffected: "NA",
      ActivityType: "NA",
      cttstatus: "Pending Assigned",
    },
    {
      id: "",
      Source: "NOVA",
      PriorityClass: "P16",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Frequent disconnection",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Intermittent",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "",
      Source: "NOVA",
      PriorityClass: "P20",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Frequent disconnection",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Intermittent",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "",
      Source: "NOVA",
      PriorityClass: "P21",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Frequent disconnection",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Intermittent",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "",
      Source: "NOVA",
      PriorityClass: "P22",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Frequent disconnection",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Intermittent",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "",
      Source: "NOVA",
      PriorityClass: "P6",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
  ],
  Table2: [
    {
      id: "1",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "3",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "2",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "19",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "3",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "26",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "4",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "43",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "5",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "51",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "6",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "52",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "7",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "63",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "8",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "65",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "9",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "70",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "10",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "72",
      STT_R2_Class_Matrix: "NTT CUSTOMER FAILURE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "11",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "73",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "12",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "77",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "13",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "111",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "14",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "158",
      STT_R2_Class_Matrix: "NTT CUSTOMER FAILURE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "15",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "159",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "16",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "161",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "17",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "165",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "18",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "166",
      STT_R2_Class_Matrix: "NTT CUSTOMER FAILURE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "19",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "174",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "20",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "175",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "21",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "180",
      STT_R2_Class_Matrix: "OUTAGE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "22",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "182",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "23",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "193",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "24",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "197",
      STT_R2_Class_Matrix: "NTT CUSTOMER FAILURE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "25",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "198",
      STT_R2_Class_Matrix: "OUTAGE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "26",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "207",
      STT_R2_Class_Matrix: "OUTAGE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "27",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "228",
      STT_R2_Class_Matrix: "OUTAGE_ONLINE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "28",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "231",
      STT_R2_Class_Matrix: "NTT CUSTOMER FAILURE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "29",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "238",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "30",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "241",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "31",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "256",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "32",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "267",
      STT_R2_Class_Matrix: "OUTAGE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "33",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "289",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "34",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "305",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "35",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "30",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "36",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "338",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "37",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "347",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "38",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "356",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "39",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "357",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "40",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "378",
      STT_R2_Class_Matrix: "NTT CUSTOMER FAILURE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "41",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "381",
      STT_R2_Class_Matrix: "NTT CUSTOMER FAILURE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "42",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "387",
      STT_R2_Class_Matrix: "NTT CUSTOMER FAILURE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "43",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "393",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "44",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "423",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "45",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "434",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "46",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "451",
      STT_R2_Class_Matrix: "OUTAGE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "47",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "454",
      STT_R2_Class_Matrix: "OUTAGE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "48",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "468",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "49",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "474",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "50",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "480",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "51",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "487",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "52",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "488",
      STT_R2_Class_Matrix: "OUTAGE_ONLINE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "53",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "495",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },

    {
      id: "54",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "497",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "55",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "498",
      STT_R2_Class_Matrix: "OUTAGE_ONLINE",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "56",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "512",
      STT_R2_Class_Matrix: "NTT Degradation",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "57",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "526",
      STT_R2_Class_Matrix: "NTT FAULT RECTIFICATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "58",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "527",
      STT_R2_Class_Matrix: "NTT DEGRADATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Quality",
      subarea: "HSI Connection issue",
      srcasecategory: "Domestic-Slow Browsing",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Slow Browsing",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "59",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "528",
      STT_R2_Class_Matrix: "NTT FAULT RECTIFICATION",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "60",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "PassMsg1",
      STT_R2_Class_Matrix: " ",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "61",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "PassMsg5",
      STT_R2_Class_Matrix: " ",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "62",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "PassMsg7",
      STT_R2_Class_Matrix: " ",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "63",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "PassMsg28",
      STT_R2_Class_Matrix: " ",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "64",
      Source: "NOVA",
      AccessType: "FTTH",
      AdvisoryClass: "PassMsg6",
      STT_R2_Class_Matrix: " ",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "65",
      Source: "NOVA",
      AccessType: "VDSL",
      AdvisoryClass: "PassMsg1",
      STT_R2_Class_Matrix: " ",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "66",
      Source: "NOVA",
      AccessType: "VDSL",
      AdvisoryClass: "PassMsg5",
      STT_R2_Class_Matrix: " ",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "67",
      Source: "NOVA",
      AccessType: "VDSL",
      AdvisoryClass: "PassMsg6",
      STT_R2_Class_Matrix: " ",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "68",
      Source: "NOVA",
      AccessType: "VDSL",
      AdvisoryClass: "PassMsg7",
      STT_R2_Class_Matrix: "",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "69",
      Source: "NOVA",
      AccessType: "VDSL",
      AdvisoryClass: "PassMsg8",
      STT_R2_Class_Matrix: "",
      TicketType: "NOVA",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "All Services Down",
      srcasecategory: "Line Disconnect",
      srstatus: "In Progress",
      assignment: "WIDER_TMUC_TECH_SOC2",
      CttTicketType: "Customer Trouble Ticket",
      TicketSubType: "Reactive",
      cttcategory: "Failure",
      cttdiagnosiscode: "NA",
      cttsymptomcode: "Line Disconnect",
      serviceaffected: "HSI",
      ActivityType: "RNO Troubleshooting",
      cttstatus: "In Progress",
    },
    {
      id: "70",
      Source: "ICP",
      AccessType: "",
      AdvisoryClass: "PassMessage20",
      STT_R2_Class_Matrix: "",
      TicketType: "ICP",
      srtype: "Fault",
      srarea: "Service Failure",
      subarea: "Connection Failure",
      srcasecategory: "PPPOE - Cannot Connect (OFF)",
      srstatus: "Assigned",
      assignment: "TM CCR Technical CPC Follow Up",
      CttTicketType: "Customer TT",
      TicketSubType: "Trouble Report (TR)",
      cttcategory: "NA",
      cttdiagnosiscode: "LOCAL_LOOP",
      cttsymptomcode: "DSL_LineDisconnect",
      serviceaffected: "NA",
      ActivityType: "NA",
      cttstatus: "Pending Assigned",
    },
  ],
}

// Fallback note for the TaaS case when SPICE returns no fault information.
// EasyFix reads fault information from SPICE only, so with no response the note
// would arrive blank; this gives the field team a next action instead, pointing
// them at the current Camelia remark.
const FIELD_TEAM_REMARK =
  "Session offline. Fiber reading below threshold. Field team to check latest Camelia remark = failure and restore service accordingly"

// Fallback note for the TaaS case when SPICE *did* answer but returned nothing
// usable - an empty diagnosis, or only the generic "CSP to: Create CTT..."
// instruction addressed to the agent rather than to the field team.
//
// Kept separate from FIELD_TEAM_REMARK on purpose. That one asserts specific
// findings ("Session offline. Fiber reading below threshold."), which are only
// safe to state when SPICE has not responded at all and the offline session is
// what brought the customer here. Where SPICE answered but could not diagnose,
// claiming those readings would put findings on the ticket that nobody measured.
const SPICE_INCOMPLETE_REMARK =
  "EasyFix diagnose incomplete result from SPICE. Field team to check CAMELIA in tablet for next action"

export {
  SRTTServiceAdvisoryTable1,
  FIELD_TEAM_REMARK,
  SPICE_INCOMPLETE_REMARK,
}
